import React, { useState } from 'react';
import { get, isEmpty } from 'lodash';
import { Link, Route } from 'react-router-dom';
import { useSelect, useAction, useModal } from 'hooks';
import { STATUS } from '../../constants';
import { Icon, Modal, Loader } from 'components';
// import SOA from '../cpc/SOA';
import moment from 'moment';
import Cookie from 'js-cookie';

export const Status = ({ value, className, type }) => {
  
  const newtype = type === 'lg' ? 'classLg' : 'classSm'

  if(value === STATUS.FOR_PRE_EVALUATION.value){
    return (
      <div className={`${STATUS.FOR_PRE_EVALUATION[newtype]} ${className}`}>
        <span>{type === 'sm' ? value : STATUS.FOR_PRE_EVALUATION.remarks}</span>
      </div>
    )
  }

  if(value === STATUS.FOR_ASSESSMENT.value){
    return (
      <div className={`${STATUS.FOR_ASSESSMENT[newtype]} ${className}`}>
        <span>{type === 'sm' ? value : STATUS.FOR_ASSESSMENT.remarks}</span>
      </div>
    )
  }

  if(value === STATUS.FOR_APPEARANCE.value){
    return (
      <div className={`${STATUS.FOR_APPEARANCE[newtype]} ${className}`}>
        <span>{type === 'sm' ? value : STATUS.FOR_APPEARANCE.remarks}</span>
      </div>
    )
  }

  if(value === STATUS.FOR_APPOINTMENT.value){
    return (
      <div className={`${STATUS.FOR_APPOINTMENT[newtype]} ${className}`}>
        <span>{type === 'sm' ? value : STATUS.FOR_APPOINTMENT.remarks}</span>
      </div>
    )
  }

  if(value === STATUS.FOR_RESUBMISSION.value){
    return (
      <div className={`${STATUS.FOR_RESUBMISSION[newtype]} ${className}`}>
        <span>{type === 'sm' ? value : STATUS.FOR_RESUBMISSION.remarks}</span>
      </div>
    )
  }

  if(value === STATUS.FOR_PAYMENT.value){
    return (
      <div className={`${STATUS.FOR_PAYMENT[newtype]} ${className}`}>
        <span>{type === 'sm' ? value : STATUS.FOR_PAYMENT.remarks}</span>
      </div>
    )
  }

  if(value === STATUS.WAITING_FOR_PAYMENT.value){
    return (
      <div className={`${STATUS.WAITING_FOR_PAYMENT[newtype]} ${className}`}>
        <span>{type === 'sm' ? value : STATUS.WAITING_FOR_PAYMENT.remarks}</span>
      </div>
    )
  }

  if(value === STATUS.FOR_HEARING.value){
    return (
      <div className={`${STATUS.FOR_HEARING[newtype]} ${className}`}>
        <span>{type === 'sm' ? value : STATUS.FOR_HEARING.remarks}</span>
      </div>
    )
  }

  if(value === STATUS.FOR_CPC_DECISION.value){
    return (
      <div className={`${STATUS.FOR_CPC_DECISION[newtype]} ${className}`}>
        <span>{type === 'sm' ? STATUS.FOR_CPC_DECISION.new_value : STATUS.FOR_CPC_DECISION.remarks}</span>
      </div>
    )
  }

  if(value === STATUS.APPROVED.value){
    return (
      <div className={`${STATUS.APPROVED[newtype]} ${className}`}>
        <span>{type === 'sm' ? value : STATUS.APPROVED.remarks}</span>
      </div>
    )
  }

  if(value === STATUS.PENDING.value){
    return (
      <div className={`${STATUS.PENDING[newtype]} ${className}`}>
        <span>{type === 'sm' ? value : STATUS.PENDING.remarks}</span>
      </div>
    )
  }

  if(value === STATUS.PAID.value){
    return (
      <div className={`${STATUS.PAID[newtype]} ${className}`}>
        <span>{type === 'sm' ? value : STATUS.PAID.remarks}</span>
      </div>
    )
  }

  if(value === STATUS.FOR_PRINTING.value){
    return (
      <div className={`${STATUS.FOR_PRINTING[newtype]} ${className}`}>
        <span>{type === 'sm' ? STATUS.FOR_PRINTING.new_value : STATUS.FOR_PRINTING.remarks}</span>
      </div>
    )
  }

  if(value === STATUS.FOR_RELEASE.value){
    return (
      <div className={`${STATUS.FOR_RELEASE[newtype]} ${className}`}>
        <span>{type === 'sm' ? value : STATUS.FOR_RELEASE.remarks}</span>
      </div>
    )
  }

  if(value === STATUS.RELEASED.value){
    return (
      <div className={`${STATUS.RELEASED[newtype]} ${className}`}>
        <span>{type === 'sm' ? value : STATUS.RELEASED.remarks}</span>
      </div>
    )
  }

  if(value === STATUS.FOR_BOARD_1.value){
    return (
      <div className={`${STATUS.FOR_BOARD_1[newtype]} ${className}`}>
        <span>{type === 'sm' || type === 'xs' ? STATUS.FOR_BOARD_1.new_value : STATUS.FOR_BOARD_1.remarks}</span>
      </div>
    )
  }

  if(value === STATUS.FOR_BOARD_2.value){
    return (
      <div className={`${STATUS.FOR_BOARD_2[newtype]} ${className}`}>
        <span>{type === 'sm' || type === 'xs' ? STATUS.FOR_BOARD_2.new_value : STATUS.FOR_BOARD_2.remarks}</span>
      </div>
    )
  }

  if(value === STATUS.FOR_BOARD_3.value){
    return (
      <div className={`${STATUS.FOR_BOARD_3[newtype]} ${className}`}>
        <span>{type === 'sm' || type === 'xs' ? STATUS.FOR_BOARD_3.new_value : STATUS.FOR_BOARD_3.remarks}</span>
      </div>
    )
  }

  if(value === STATUS.APPLICATION_RECEIVED.value){
    return (
      <div className={`${STATUS.APPLICATION_RECEIVED[newtype]} ${className}`}>
        <span>{type === 'sm' ? value : STATUS.APPLICATION_RECEIVED.remarks}</span>
      </div>
    )
  }

  if(value === STATUS.FOR_ED_APPROVAL.value){
    return (
      <div className={`${STATUS.FOR_ED_APPROVAL[newtype]} ${className}`}>
        <span>{type === 'sm' ? value : STATUS.FOR_ED_APPROVAL.remarks}</span>
      </div>
    )
  }

  return null
}

const ContainerTransactionItem = ({ data }) => {
  
  const token = Cookie.get('ltfrb-site:token');
  const user = useSelect('auth.user')
  const [isLoadingNoticeOfHearing,setIsLoadingNoticeOfHearing] = useState(false)
  const paymentFees = useSelect('application.listPaymentFeesByPaymentIds', { id: get(data, 'id') })
  
  const totalAmount = Object.values(paymentFees).reduce((accumulator, current) => {
    return accumulator + +get(current, 'attributes.total_amount_fee')
  }, 0)

  // const selectedPaymentTranscation = useSelect('application.paymentTransctionTypeIdsByPaymentId', { id: get(data, 'id') });
  // const selectedTransactionType = useSelect('transactionType.transactionTypeByIds', { ids: selectedPaymentTranscation });
  const selectedApplication = useSelect('application.selected', { id: get(data, 'relationships.module.data.id') });
  const selectedOwnershipType = useSelect('ownershipType.selected', { id: +get(selectedApplication, 'attributes.ownership_type_id') });
  const selectedAppointment = useSelect('application.selectedAppointment', { id: get(data, 'attributes.appointment_id') });
  const selectedReappointment = useSelect('application.selectedReappointment', { id: get(data, 'attributes.reappointment_id') });
  
  const [isOpenPaymentModal, onOpenPaymentModal, onClosePaymentModal] = useModal()
  const [isOpenSOAModal, onOpenSOAModal, onCloseSOAModal] = useModal()
  const [isOpenDismissalOrderModal, onOpenDismissalOrderModal, onCloseDismissalOrderModal] = useModal()
  const [isOpenApplicationFormModal, onOpenApplicationFormModal, onCloseApplicationFormModal] = useModal()
  // const [isOpenCPCModal, onOpenCPCModal, onCloseCPCModal] = useModal()
  const [paymentInfo, setPaymentInfo] = useState(null)
  const payNow = useAction('payment.payNow')
  const paying = useSelect('loading.isLoading', { type: 'payment.payNow' })
  const [noticeOfHearingIsOpen, noticeOfHearingOnOpen, noticeOfHearingOnClose] = useModal()
  // const [isOpenORModal, onOpenORModal, onCloseORModal] = useModal()

  const handlePayNow = e => {
    e.preventDefault()
    onOpenPaymentModal()
    payNow(data.id, (response) => {
      setPaymentInfo(response)
      
    })
  }

  const handleViewSOA = e => {
    e.preventDefault() 
    onOpenSOAModal()
  }

  const handleViewDismissalOrder = e => {
    e.preventDefault() 
    onOpenDismissalOrderModal()
  }

  // const handleViewOR = e => {
  //   e.preventDefault() 
  //   onOpenORModal()
  // }

  const onPrintApplicationForm = e => {
    e.preventDefault()
    onOpenApplicationFormModal()
  }

  const onLoadNoticeOfHearing = () => {
    setIsLoadingNoticeOfHearing(false)
  }
  
  const handleOpenNoticeOfHearing = (e) => {
    e.preventDefault()
    noticeOfHearingOnOpen()
  }

  // const handleOpenCPC = e => {
  //   e.preventDefault()
  //   onOpenCPCModal()
  // }

  return (
    <>
    <div className="border-2 border-gray-400 flex flex-col p-2 rounded bg-white">
      <div className="flex flex-col lg:flex-row xl:flex-row bg-gray-300 p-1 rounded">
        <div className="w-full lg:w-5/12 flex flex-col xl:flex-row lg:flex-row items-center px-1">
          <b className="text-primary text-lg flex-1 font-medium">ID. : {`${get(data,'attributes.module_type')}${get(data, 'id').toString().padStart(6,'0')}`}</b>
        </div>
        {get(data, 'attributes.refno') &&
        <div className="w-full lg:w-7/12 flex flex-col xl:flex-row lg:flex-row items-center justify-end px-1 w-full">
          <span className="text-sm mr-1">REF NO. : </span>
          <b className="text-primary text-lg font-medium mr-3">{get(data, 'attributes.refno') || '-'}</b>
          {get(data, 'attributes.status') &&
            <>
              <span className="text-sm mr-1">Payment Status</span>
              <Status type="sm" value={get(data, 'attributes.status')}/>
            </>
          }
        </div>}
       
      </div>
      {/* <div className="flex flex-1 flex-col xl:flex-row lg:flex-row">
        <div className="flex-col w-full xl:w-5/12 lg:w-5/12 space-y-1" >
          <div className="flex-1 flex space-x-1 items-center">
            <span className="w-32 xl:w-40 lg:w-40 text-sm text-left xl:text-right lg:text-right text-gray-600">Transaction Type<small className="px-2">:</small></span>
            <span className="flex-1 text-sm font-medium">{selectedTransactionType.map(x => get(x, 'attributes.name')).join(', ')}</span>
          </div>
        </div>
        <div className="flex-col space-y-1 flex-1">
          {['WAITING FOR PAYMENT', 'FOR APPOINTMENT','FOR PAYMENT'].indexOf(get(data, 'attributes.application_status')) > -1 && (get(data, 'attributes.amount') || totalAmount) &&
          <div className="flex-1 flex space-x-1 items-center">
            <span className="w-32 xl:w-64 lg:w-40 text-sm text-left xl:text-right lg:text-right text-gray-600">Total Amount<small className="px-2">:</small></span>
            <span className="flex-1 text-info text-sm xl:text-xl lg:text-lg font-medium text-2xl text-left xl:text-right lg:text-right">{(get(data, 'attributes.amount') || totalAmount).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}</span>
          </div>}
          
          {selectedAppointment && get(data, 'attributes.application_status') === 'FOR APPEARANCE' && (
            <div className="flex-1 flex space-x-1 items-center">
              <span className="w-32 xl:w-64 lg:w-40 text-sm text-left xl:text-right lg:text-right text-gray-600">Appointment<small className="px-2">:</small></span>
              <span className="flex-1 text-info text-sm xl:text-xl lg:text-lg font-medium text-2xl text-left xl:text-right lg:text-right">
                {moment(get(selectedAppointment, 'attributes.appointment_date')).format('MMM DD, YYYY')}&nbsp;-&nbsp;
                {get(selectedAppointment, 'attributes.period')}
              </span>
            </div>
          )}
          {get(data, 'attributes.hearing_date') && get(data, 'attributes.application_status') === 'FOR HEARING' && (
            <div className="flex-1 flex space-x-1 items-center">
              <span className="w-32 xl:w-64 lg:w-40 text-sm text-left xl:text-right lg:text-right text-gray-600">Hearing Date<small className="px-2">:</small></span>
              <span className="flex-1 text-info text-sm xl:text-xl lg:text-lg font-medium text-2xl text-left xl:text-right lg:text-right">
                {moment(get(data, 'attributes.hearing_date')).format('MMM DD, YYYY hh:mm:ss A')}
                
              </span>
            </div>
          )}
        </div>
      </div> */}
      {get(selectedApplication, 'attributes.case_number') &&
      <div className="flex-1 flex space-x-1 items-center">
        <span className="w-32 xl:w-40 lg:w-40 text-sm text-left xl:text-right lg:text-right text-gray-600">Case Number<small className="px-2">:</small></span>
        <span className="flex-1 text-sm font-medium">{get(selectedApplication, 'attributes.case_number')}</span>
      </div>}
      <div className="flex-1 flex space-x-1 items-center">
        <span className="w-32 xl:w-40 lg:w-40 text-sm text-left xl:text-right lg:text-right text-gray-600">Ownership Type<small className="px-2">:</small></span>
        <span className="flex-1 text-sm font-medium">{get(selectedOwnershipType, 'attributes.name')}</span>
      </div>
      {selectedAppointment && get(data, 'attributes.application_status') === 'FOR APPEARANCE' && (
      <div className="flex-1 flex space-x-1 items-center">
        <span className="w-32 xl:w-40 lg:w-40 text-sm text-left xl:text-right lg:text-right text-gray-600">Appointment Date<small className="px-2">:</small></span>
        <span className="flex-1 text-sm font-medium">{selectedReappointment ? moment(get(selectedReappointment, 'attributes.appointment_date')).format('MMM DD, YYYY') : moment(get(selectedAppointment, 'attributes.appointment_date')).format('MMM DD, YYYY')} &nbsp;-&nbsp;
          {selectedReappointment ? 'Reappointed' : get(selectedAppointment, 'attributes.period')}
        </span>
      </div>)}
      {get(data, 'attributes.hearing_date') && get(data, 'attributes.application_status') === 'FOR HEARING' && (
      <div className="flex-1 flex space-x-1 items-center">
        <span className="w-32 xl:w-40 lg:w-40 text-sm text-left xl:text-right lg:text-right text-gray-600">Hearing Date<small className="px-2">:</small></span>
        <span className="flex-1 text-sm font-medium">{moment(get(data, 'attributes.hearing_date')).format('MMM DD, YYYY hh:mm:ss A')}</span>
      </div>)}
      {['WAITING FOR PAYMENT', 'FOR APPOINTMENT','FOR PAYMENT'].indexOf(get(data, 'attributes.application_status')) > -1 && (get(data, 'attributes.amount') || totalAmount) && (
      <div className="flex-1 flex space-x-1 items-center">
        <span className="w-32 xl:w-40 lg:w-40 text-sm text-left xl:text-right lg:text-right text-gray-600">Total Amount<small className="px-2">:</small></span>
        <span className="flex-1 text-sm font-medium">{(get(data, 'attributes.amount') || totalAmount).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}</span>
      </div>)}
      <div className="flex-1 flex space-x-1 items-center">
        <span className="w-32 xl:w-40 lg:w-40 text-sm text-left xl:text-right lg:text-right text-gray-600">Status<small className="px-2">:</small></span>
        <Status type="sm" value={get(data, 'attributes.application_status')}/>
      </div>
      <div className="flex-1 flex space-x-1 items-center my-1">
        <span className="w-32 xl:w-40 lg:w-40 text-sm text-left xl:text-right lg:text-right text-gray-600">Remarks<small className="px-2">:</small></span>
        <span className="flex-1 text-sm text-info">{get(data, 'attributes.remarks')}</span>
      </div>
      <Route exact path="/application-form" render={() => (
        <>
          <hr className="my-3 text-gray-300"/>
          <div className="flex items-center space-x-3">
            <Link 
              to={`/application/${data.id}/view`} 
              className="inline-flex space-x-2 bg-primary px-3 py-2 rounded border border-primary shadow">
              <Icon.Eye className="!text-white"/>
              <span className="text-sm font-medium text-white">More...</span>
            </Link>
          </div>
          
        </>
      )} />
      
      <Route exact path="/application/:payment_id/view" render={() => (
        <>
          <hr className="my-3 text-gray-300"/>
          <div className="flex items-center gap-x-2 gap-y-1 flex-wrap">
            {get(data,'attributes.module_type') === 'CPC' &&
            ['FOR ASSESSMENT', 'FOR APPEARANCE', 'FOR RESUBMISSION'].indexOf(get(data, 'attributes.application_status')) > -1  &&
            <a href="jsx-a11y/anchor-is-valid" 
              onClick={onPrintApplicationForm} 
              className="inline-flex space-x-2 bg-white px-3 py-2 rounded border border-primary shadow"><Icon.Printer />
              <span className="text-sm font-medium text-primary">Print Application Form</span>
            </a>}
            {get(data, 'attributes.application_status') === 'FOR APPOINTMENT' &&
            <Link 
              to={`/application/${data.id}/appointment`} 
              className="inline-flex space-x-2 bg-white px-3 py-2 rounded border border-primary shadow">
              <Icon.Calendar /><span className="text-sm font-medium text-primary">Appointment</span>
              <span className="flex h-3 w-3 relative">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-pink-400 opacity-75"></span>
                <span className="relative inline-flex rounded-full h-3 w-3 bg-pink-500"></span>
              </span>
            </Link>}
            {get(data, 'attributes.application_status') === 'FOR RESUBMISSION' &&
            <Link 
              to={`/application/${data.id}/resubmit`} 
              className="inline-flex space-x-2 bg-white px-3 py-2 rounded border border-primary shadow">
              <Icon.Resubmit /><span className="text-sm font-medium text-primary">Resubmit</span>
              <span className="flex h-3 w-3 relative">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-pink-400 opacity-75"></span>
                <span className="relative inline-flex rounded-full h-3 w-3 bg-pink-500"></span>
              </span>
            </Link>}
            {['FOR APPOINTMENT','FOR PAYMENT', 'WAITING FOR PAYMENT', 'FOR HEARING','FOR PRINTING', 'RELEASED', 'FOR BOARD 1', 'FOR BOARD 2', 'FOR BOARD 3'].indexOf(get(data, 'attributes.application_status')) > -1  &&
            <a href="jsx-a11y/anchor-is-valid" 
              onClick={handleViewSOA} 
              className="inline-flex space-x-2 bg-white px-3 py-2 rounded border border-primary shadow"><Icon.Statement/>
              <span className="text-sm font-medium text-primary">SOA</span>
            </a>}
            {/* {['APPLICATION RECEIVED', 'FOR HEARING','FOR PRINTING', 'RELEASED', 'FOR BOARD 1', 'FOR BOARD 2', 'FOR BOARD 3', 'FOR PRINTING', 'RELEASED'].indexOf(get(data, 'attributes.application_status')) > -1  && get(data, 'attributes.or_number') &&
            <a href="jsx-a11y/anchor-is-valid" 
              onClick={handleViewOR} 
              className="inline-flex space-x-2 bg-white px-3 py-2 rounded border border-primary shadow"><Icon.Statement/>
              <span className="text-sm font-medium text-primary">eOR</span>
            </a>} */}
            {/* {['FOR HEARING'].indexOf(get(data, 'attributes.application_status')) > -1  && get(data, 'attributes.hearing_date') && get(data, 'attributes.noh_generated_at') &&
            <a href="jsx-a11y/anchor-is-valid" 
              onClick={handleOpenNoticeOfHearing} 
              className="inline-flex space-x-2 bg-white px-3 py-2 rounded border border-primary shadow"><Icon.Statement/>
              <span className="text-sm font-medium text-primary" title="Notice Of Hearing">NOH</span>
            </a>} */}
            {/* {['RELEASED'].indexOf(get(data, 'attributes.application_status')) > -1  &&
            <a href="jsx-a11y/anchor-is-valid" 
              onClick={handleOpenCPC} 
              className="inline-flex space-x-2 bg-white px-3 py-2 rounded border border-primary shadow"><Icon.Statement/>
              <span className="text-sm font-medium text-primary" title="CPC Certificate">CPC</span>
            </a>} */}
            {get(data, 'attributes.application_status') === 'FOR PAYMENT' &&
            <a href="jsx-a11y/anchor-is-valid" 
              onClick={handlePayNow} 
              className="inline-flex space-x-2 bg-white px-3 py-2 rounded border border-primary shadow"><Icon.Receipt className="text-red-600"/>
              <span className="text-sm font-medium text-primary">Pay Now</span>
              <span className="flex h-3 w-3 relative">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-pink-400 opacity-75"></span>
                <span className="relative inline-flex rounded-full h-3 w-3 bg-pink-500"></span>
              </span>
            </a>}
          </div>
        </>
      )}/>
      <Route exact path="/" render={() => (
        <>
          <hr className="my-3 text-gray-300"/>
          <div className="flex items-center gap-x-2 gap-y-1 flex-wrap">
            <Link 
              to={`/application/${data.id}/view`} 
              className="inline-flex space-x-2 bg-primary px-3 py-2 rounded border border-primary shadow">
              <Icon.Eye className="!text-white"/>
              <span className="text-sm font-medium text-white">More...</span>
            </Link>
            {get(data,'attributes.module_type') === 'CPC' &&
            ['FOR ASSESSMENT', 'FOR APPEARANCE', 'FOR RESUBMISSION'].indexOf(get(data, 'attributes.application_status')) > -1  &&
            <a href="jsx-a11y/anchor-is-valid" 
              onClick={onPrintApplicationForm} 
              className="inline-flex space-x-2 bg-white px-3 py-2 rounded border border-primary shadow"><Icon.Printer />
              <span className="text-sm font-medium text-primary">Print Application Form</span>
            </a>}
            {get(data, 'attributes.application_status') === 'FOR APPOINTMENT' &&
            <Link 
              to={`/application/${data.id}/appointment`} 
              className="inline-flex space-x-2 bg-white px-3 py-2 rounded border border-primary shadow">
              <Icon.Calendar /><span className="text-sm font-medium text-primary">Appointment</span>
              <span className="flex h-3 w-3 relative">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-pink-400 opacity-75"></span>
                <span className="relative inline-flex rounded-full h-3 w-3 bg-pink-500"></span>
              </span>
            </Link>}
            {get(data, 'attributes.application_status') === 'FOR RESUBMISSION' &&
            <Link 
              to={`/application/${data.id}/resubmit`} 
              className="inline-flex space-x-2 bg-white px-3 py-2 rounded border border-primary shadow">
              <Icon.Resubmit /><span className="text-sm font-medium text-primary">Resubmit</span>
              <span className="flex h-3 w-3 relative">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-pink-400 opacity-75"></span>
                <span className="relative inline-flex rounded-full h-3 w-3 bg-pink-500"></span>
              </span>
            </Link>}
            {['FOR APPOINTMENT','FOR PAYMENT', 'WAITING FOR PAYMENT', 'FOR HEARING','FOR PRINTING', 'RELEASED', 'FOR BOARD 1', 'FOR BOARD 2', 'FOR BOARD 3'].indexOf(get(data, 'attributes.application_status')) > -1  &&
            <a href="jsx-a11y/anchor-is-valid" 
              onClick={handleViewSOA} 
              className="inline-flex space-x-2 bg-white px-3 py-2 rounded border border-primary shadow"><Icon.Statement/>
              <span className="text-sm font-medium text-primary">SOA</span>
            </a>}
            {/* {['FOR APPOINTMENT','FOR PAYMENT', 'WAITING FOR PAYMENT', 'FOR HEARING','FOR PRINTING', 'RELEASED', 'FOR BOARD 1', 'FOR BOARD 2', 'FOR BOARD 3'].indexOf(get(data, 'attributes.application_status')) > -1  && */}
            {['FOR APPOINTMENT','FOR PAYMENT', 'WAITING FOR PAYMENT', 'FOR HEARING', 'FOR CPC DECISION', 'FOR PRINTING', 'RELEASED', 'FOR BOARD 1', 'FOR BOARD 2', 'FOR BOARD 3'].indexOf(get(data, 'attributes.application_status')) > -1  &&
              !isEmpty(get(data, "attributes.dismissed_at")) && !isEmpty(get(data, "attributes.dismissed_by"))  ?
                <a href="jsx-a11y/anchor-is-valid" 
                  onClick={handleViewDismissalOrder} 
                  className="inline-flex space-x-2 bg-white px-3 py-2 rounded border border-primary shadow"><Icon.Statement/>
                  <span className="text-sm font-medium text-primary">Dismissal Order</span>
                </a> : ''
            }
            {/* {['APPLICATION RECEIVED', 'FOR HEARING','FOR PRINTING', 'RELEASED', 'FOR BOARD 1', 'FOR BOARD 2', 'FOR BOARD 3', 'FOR PRINTING', 'RELEASED'].indexOf(get(data, 'attributes.application_status')) > -1  && get(data, 'attributes.or_number') && 
            <a href="jsx-a11y/anchor-is-valid" 
              onClick={handleViewOR} 
              className="inline-flex space-x-2 bg-white px-3 py-2 rounded border border-primary shadow"><Icon.Statement/>
              <span className="text-sm font-medium text-primary">eOR</span>
            </a>} */}
            {/* {['FOR HEARING'].indexOf(get(data, 'attributes.application_status')) > -1  && get(data, 'attributes.hearing_date') && get(data, 'attributes.noh_generated_at') &&
            <a href="jsx-a11y/anchor-is-valid" 
              onClick={handleOpenNoticeOfHearing} 
              className="inline-flex space-x-2 bg-white px-3 py-2 rounded border border-primary shadow"><Icon.Statement/>
              <span className="text-sm font-medium text-primary" title="Notice Of Hearing">NOH</span>
            </a>} */}
            {/* {['RELEASED'].indexOf(get(data, 'attributes.application_status')) > -1  &&
            <a href="jsx-a11y/anchor-is-valid" 
              onClick={handleOpenCPC} 
              className="inline-flex space-x-2 bg-white px-3 py-2 rounded border border-primary shadow"><Icon.Statement/>
              <span className="text-sm font-medium text-primary" title="CPC Certificate">CPC</span>
            </a>} */}
            {get(data, 'attributes.application_status') === 'FOR PAYMENT' &&
            <a href="jsx-a11y/anchor-is-valid" 
              onClick={handlePayNow} 
              className="inline-flex space-x-2 bg-white px-3 py-2 rounded border border-primary shadow"><Icon.Receipt className="text-red-600"/>
              <span className="text-sm font-medium text-primary">Pay Now</span>
              <span className="flex h-3 w-3 relative">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-pink-400 opacity-75"></span>
                <span className="relative inline-flex rounded-full h-3 w-3 bg-pink-500"></span>
              </span>
            </a>}
          </div>
        </>
      )} 
      />
    </div>
    <Modal size="lg" isOpen={isOpenPaymentModal} onClose={onClosePaymentModal}>
      <div className="p-0 xl:p-5 lg:p-2">
        {paying && 
          <div className="flex flex-col items-center justify-center">
            <span className="animate-pulse text-bold text-info">Witing for payment provider...</span>
            <Loader.Table />
          </div>
        }
        {!paying &&
        <iframe 
          title="Payment Gateway"
          className="w-full"
          style={{ height: 500 }}
          src={`${get(paymentInfo, `${data.id}.attributes.url`)}?redirect_url=${window.location.origin}`} />}
      </div>
    </Modal>
    <Modal size="lg" isOpen={isOpenSOAModal} onClose={onCloseSOAModal}>
      {/* <SOA id={get(data, 'id')}/> */}
      <b className="text-primary font-medium">Assessment / Order of Payment</b>
      <iframe 
        title="Print Application Form"
        className="w-full border-0"
        style={{ height: 500 }}
        src={`${process.env.REACT_APP_ENPOINT}site/payments/${get(data, 'id')}/receipt?email=${get(user, 'attributes.email')}&token=${token}`}
      />
    </Modal>
    <Modal size="lg" isOpen={isOpenDismissalOrderModal} onClose={onCloseDismissalOrderModal}>
      {/* <SOA id={get(data, 'id')}/> */}
      <b className="text-primary font-medium">Dismissal Order</b>
      <iframe 
        title="Print Application Form"
        className="w-full border-0"
        style={{ height: 500 }}
        src={`${process.env.REACT_APP_ENPOINT}site/payments/${get(data, 'id')}/view_dismissal?email=${get(user, 'attributes.email')}&token=${token}`}
      />
    </Modal>
    <Modal size="lg" isOpen={isOpenApplicationFormModal} onClose={onCloseApplicationFormModal}>
      <b className="text-primary font-medium">Application Form</b>
      <iframe 
        title="Print Application Form"
        className="w-full border-0"
        style={{ height: 500 }}
        src={`${process.env.REACT_APP_ENPOINT}site/payments/${get(data, 'id')}/application_form?email=${get(user, 'attributes.email')}&token=${token}`}
      />
    </Modal>
    <Modal size="lg" isOpen={noticeOfHearingIsOpen} onClose={noticeOfHearingOnClose}>
      <b className="text-primary font-medium">Notice of Hearing</b>
      <div className="p-5">
        {isLoadingNoticeOfHearing && <Loader.Table />}
        <iframe
          onLoad={onLoadNoticeOfHearing}
          title="CPC Certificate"
          className={`w-full ${isLoadingNoticeOfHearing ? 'invisible' : 'visible'}`}
          style={{
            height: 500
          }}
          src={`${process.env.REACT_APP_ENPOINT}site/payments/${get(data, 'id')}/view_noh?email=${get(user, 'attributes.email')}&token=${token}`}/>
      </div>
    </Modal>
    {/* <Modal size="lg" isOpen={isOpenORModal} onClose={onCloseORModal}>
      <b className="text-primary font-medium">Electronic Original Receipt</b>
      <iframe 
        title="Electronic Original Receipt"
        className="w-full border-0"
        style={{ height: 500 }}
        src={`${process.env.REACT_APP_ENPOINT}site/payments/${get(data, 'id')}/view_or?email=${get(user, 'attributes.email')}&token=${token}`}
      />
    </Modal> */}
    {/* <Modal size="lg" isOpen={isOpenCPCModal} onClose={onCloseCPCModal}>
      <b className="text-primary font-medium">Certificate</b>
      <div className="p-5">
        {isLoadingNoticeOfHearing && <Loader.Table />}
        <iframe
          onLoad={onLoadNoticeOfHearing}
          title="CPC Certificate"
          className={`w-full ${isLoadingNoticeOfHearing ? 'invisible' : 'visible'}`}
          style={{
            height: 800
          }}
          src={`${process.env.REACT_APP_ENPOINT}site/payments/${get(data, 'id')}/view_cpc?email=${get(user, 'attributes.email')}&token=${token}`}/>
      </div>
    </Modal> */}
    </>
  )

}

export default ContainerTransactionItem